import Vue from 'vue'
import Vuex from 'vuex'
import root from './modules/root'
import parcels from './modules/parcels'
import user from './modules/user'
import address from './modules/address'
import cards from './modules/cards'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    root,
    parcels,
    user,
    address,
    cards
  },
})
